import YearToDateFormats from 'pages/Reports/YearToDate/Formats';
import { Routes } from 'types/Routes';

export const menuEntries: Routes[] = [
  {
    path: '/mbapp/YearToDateSongsByFormat',
    component: YearToDateFormats,
  },
];
